<template>
  <!-- <div v-if="this.$store.state.appIsLoading == true">
    <div class="overlay">
      <div class="overlay__inner">
        <div class="overlay__content">
          <span class="spinner"></span>
        </div>
      </div>
    </div>
  </div> -->

  <router-view />
  <ShowToast />
  <DynamicDialog :contentStyle="{ padding: 0 }" />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import TempNavBar from '@/layouts/NavBar.vue'
import TempSideBar from '@/layouts/SideBar.vue'
import TempFooter from '@/layouts/FooterBar.vue'

export default defineComponent({
  name: 'App',
  components: { TempNavBar, TempSideBar, TempFooter },
  data() {
    return {
      isLoading: false,
      Notifications_a_lire: {}
    }
  },
  beforeMount() {
    Notification.requestPermission().then((result) => {
      console.log(result);
    });
  },
  mounted() {
    this.axios.get('/sanctum/csrf-cookie').then(() => {
      console.log('csrf-cookie ok')
    }).catch(() => {
      window.location.reload()
      this.$toast.add({
        severity: 'error',
        summary: 'Probleme de connexion',
        detail: 'Une erreur s\'est produite lors de la connexion au serveur !',
        life: 5000
      });
    });
  },
})
</script>

<style lang="scss">
@import './style/app.scss';
</style>
